import { render, staticRenderFns } from "./COG.vue?vue&type=template&id=8f6daa96&scoped=true&"
import script from "./COG.vue?vue&type=script&lang=js&"
export * from "./COG.vue?vue&type=script&lang=js&"
import style0 from "./COG.vue?vue&type=style&index=0&id=8f6daa96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6daa96",
  null
  
)

export default component.exports